import { useMemo } from 'react';
import { TaskCategory } from '@sib/api';

export const useTaskCategoryOptions = () =>
  useMemo(
    () =>
      Object.values(TaskCategory).map(option => ({
        label: option,
        value: option,
      })),
    []
  );
